import script from "./potentialMember.vue?vue&type=script&setup=true&lang=js"
export * from "./potentialMember.vue?vue&type=script&setup=true&lang=js"

import "./potentialMember.vue?vue&type=style&index=0&id=1546f5fa&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1546f5fa"]])

export default __exports__